module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('movieItem', {
    attrs: {
      "Title": _vm.Title[0],
      "url": _vm.url + "in_theaters"
    }
  }), _vm._v(" "), _c('movieItem', {
    attrs: {
      "Title": _vm.Title[1],
      "url": _vm.url + "top250"
    }
  }), _vm._v(" "), _c('movieItem', {
    attrs: {
      "Title": _vm.Title[2],
      "url": _vm.url + "coming_soon"
    }
  }), _vm._v(" "), _c('navtype'), _vm._v(" "), _c('download')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-00183d2a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/movie/movie.vue
// module id = 52
// module chunks = 1